import { render, staticRenderFns } from "./InvoiceParameterHeader.vue?vue&type=template&id=2c110880&"
import script from "./InvoiceParameterHeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceParameterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports